<template>
  <HgNotificationMessage
    v-if="!hasStreet"
    theme="info"
    :class="$style.noAddress"
    :showCloseButton="false"
    :showCtaButton="true"
    :ctaButtonText="t('noAddress.requestAddress')"
    :title="t('noAddress.description')"
    @cta-button-click="openAddressRequestModal"
  >
  </HgNotificationMessage>
</template>

<script lang="ts" setup>
import { HgNotificationMessage } from '@smg-real-estate/domus';
import { Address } from '@smg-real-estate/hg-rets-schema';

import {
  InteractionContainerName,
  InteractionEvent,
  InteractionGoal,
} from '@/helpers/GTM/GTMParameters';
import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineOptions({ name: 'CTANoAddress' });

interface Props {
  /**
   * Address object from the HgRets listing
   */
  address: Address | undefined;
}
const props = defineProps<Props>();

const hasStreet = computed((): boolean => {
  return !!props.address?.street;
});

const emit = defineEmits<{
  onRequestAddress: [];
}>();

function openAddressRequestModal() {
  emit('onRequestAddress');
  trackEventHarmonized(InteractionEvent.PDP_INTERACTION, {
    h_event_category_006: InteractionEvent.PDP_INTERACTION,
    h_event_action_007: InteractionGoal.REQUEST_ADDRESS,
    h_event_label_008: InteractionContainerName.ADDRESS_BOX,
  });
}
</script>

<style module lang="scss">
@import '@/assets/variables';

.noAddress {
  margin: $space-25 0 $space-150 0;

  .message {
    display: inline-flex;
    flex-direction: column;
    gap: $space-50;

    /* To even out left and right paddings and avoid overwriting HGNotificationMessage's default styles */
    padding-right: $space-25;
  }

  .description {
    max-width: fit-content;
    margin: 0;
    font-weight: bold;

    @include body-2-semi-bold;
  }
}
</style>
